import axios from 'axios';
import {Toast} from 'mint-ui';
let settings = {
    url: '',
    timeout: 60000,
    method: 'get',
    baseURL: '',
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    params: {},
    transformResponse: [function (data) {
        // Do whatever you want to transform the data
        return data;
    }],
    withCredentials: false, // default
    responseType: 'json', // default

}
export function request(data) {
    let config = Object.assign(settings, data);
    return axios.request(config);
};



// WEBPACK FOOTER //
// ./src/common/util/request.js